import React from "react";
import "../../commoncss/Common.css";

const Agentdashboard = () => {
  return (
    <>
      <div className="agent_wrapper">
        <div className="top_search_fields">
          <div className="fields_row">
            <div className="fields_item">
              <label>From</label>
              <input type="date" />
            </div>
            <div className="fields_item">
              <label>To</label>
              <input type="date" />
            </div>
    
          </div>
          <div className="btn_container">
            <button>Apply</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Agentdashboard;
